<app-confirm-dialog
  [(isOpen)]="dialogOpen"
  (handleClose)="dialogClosed()"
  (handlePrimaryButton)="exit()"
  (handleSecondaryButton)="cancel()"
  title="{{ 'common.unsavedTitle' | translate }}"
  subTitle="{{ 'common.unsavedDescription' | translate }}"
  primaryText="{{ 'common.exitWithoutSaving' | translate }}"
  secondaryText="{{ 'common.cancel' | translate }}"
></app-confirm-dialog>
